<template>
  <div>
    <hb-link
      color="secondary"
      @click="btnClickedHandler(params, 'event')"
    >
      View
    </hb-link>
  </div>
</template>

<script>
import { EventBus } from "../../../EventBus";
export default {
  data() {
    return {
      dialog: false,
      cellValueLowerCase: "",
    };
  },
  beforeMount() {},
  methods: {
    btnClickedHandler(paramData, type = "") {
      this.dialog = true;
      if (type === "event" && this.params?.event) {
        EventBus.$emit(this.params?.event?.name, {
          event: this.params?.event?.method,
          data: this.params?.data,
        });
      } else paramData.context.parent.$parent.$parent.parentMethod(paramData);
    },
  },
};
</script>
